module.exports = __webpack_public_path__ + "img/otherInHouse2.2b6d3799.jpg";